import React from "react";
import { Image } from "react-bootstrap";
import styles from "./seekHeader.module.scss";
import cx from "classnames";
import { useSelector } from "react-redux";
import Tooltip from "src/components/tooltip";

const SeekIcon = '/images/seek.gif';

const SeekHeader: React.FC = () => {
  const accountLimit = useSelector((state: any) => state.seek.accountLimit);
  const userLimit = useSelector((state: any) => state.seek.userLimit);
  const widthPercentage =
    userLimit >= accountLimit ? 100 : (userLimit / accountLimit) * 100; 

  return (
    <>
      <div className={styles.seekHeading}>
        <Image
          className={cx(styles.seekIcon)}
          src={SeekIcon}
          alt="Seek"
        />
        <p className={styles.seekTitle}>seek</p>
      </div>
      <p className={styles.seekSubText}>powered by Paperflite</p>
      <Tooltip placement="bottom-start" content="Questions consumed">
        <div className={styles.questionLimit}>
          <span className={styles.progressBar}>
            <div
              className={styles.progress}
              style={{ width: `${widthPercentage}%` }}
            ></div>
          </span>
          <span className={styles.questionLimitContent}>
            <span className={styles.questionsConsumed}> {userLimit} </span>/{" "}
            {accountLimit}{" "}
          </span>
        </div>
      </Tooltip>
    </>
  );
};

export default SeekHeader;
